import PropTypes from 'prop-types';
import React from 'react';
import ServiceTypeSelectField from './ServiceTypeSelectField';
import {
  getCaseTypeType,
  getSelectedNetwork,
  isServiceTypesReady,
  resolveServiceTypeError,
  resolveServiceTypeOptions,
  shouldDisableServiceTypes,
} from './caseServiceTypeFieldHelpers';

const CaseServiceTypeField = ({
  defaultProgramSelected,
  values,
  programsServiceTypes,
  user,
  ...props
}) => {
  const caseTypeType = getCaseTypeType(values);
  const programId = values?.program?.id;
  const selectedNetworkId = values?.network?.id;
  const selectedNetwork = getSelectedNetwork(user, selectedNetworkId);
  const serviceTypesReady = isServiceTypesReady({
    defaultProgramSelected,
    selectedNetwork,
    programsServiceTypes,
    programId,
  });
  const disableServiceTypes = shouldDisableServiceTypes({
    values,
    caseTypeType,
    serviceTypesReady,
  });
  const serviceTypes = resolveServiceTypeOptions({
    values,
    serviceTypesReady,
    defaultProgramSelected,
    user,
    programsServiceTypes,
  });

  const { input, meta = {}, ...restProps } = props;
  const errorState = resolveServiceTypeError(meta);

  const field = {
    ...input,
    name: input.name || 'service_case.service_type',
    value: input.value,
    onChange: input.onChange,
    onBlur: input.onBlur,
  };

  return (
    <ServiceTypeSelectField
      disabled={disableServiceTypes}
      options={serviceTypes}
      field={field}
      touch={() => {}}
      invalid={errorState.invalid}
      touched={errorState.touched}
      error={errorState.error}
      {...restProps}
    />
  );
};

CaseServiceTypeField.propTypes = {
  defaultProgramSelected: PropTypes.bool.isRequired,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object,
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  programsServiceTypes: PropTypes.object,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  searchChoices: PropTypes.bool,
  searchPlaceholderValue: PropTypes.string,
  user: PropTypes.shape({
    networks: PropTypes.array.isRequired,
  }).isRequired,
};

CaseServiceTypeField.defaultProps = {
  id: 'service-type',
  placeholder: 'Choose one...',
  required: true,
  searchChoices: false,
  searchPlaceholderValue: 'Search...',
  meta: undefined,
  onChange: undefined,
  programsServiceTypes: undefined,
};

export default CaseServiceTypeField;
